/**
 *
 * Surveys
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import Loader from "components/Loader"
import {
  makeSelectSurveys,
  makeSelectLeadershipSurveys,
  makeSelectGetSurvey,
  makeSelectIsLoadingSurvey,
  makeSelectSurveysTemplate,
  makeSelectIsLoadingSurveysTemplate,
  makeSelectIsLoadingSurveys,
  makeSelectGetSurveyName,
  makeSelectIsLoadingSurveyEnps,
  makeSelectSurveyEnps,
  makeSelectSurveyQualitative,
  makeSelectIsLoadingSurveyQualitative,
  makeSelectSegments,
  makeSelectIsLoadingSegments,
  makeSelectSurveyTypes,
  makeSelectIsLoadingSurveyTypes,
  makeSelectScopeTypes,
  makeSelectIsLoadingScopeTypes,
  makeSelectSurveysByIndicators,
} from "./selectors"
import {
  deleteSurveyWatcher,
  getSurveys,
  createSurvey,
  getSurveyWatcher,
  getSurveysTemplateWatcher,
  duplicateSurveyWatcher,
  getSurveyEnpsWatcher,
  getSurveyQualitativeWatcher,
  downloadSurveyWatcher,
  getSegmentsWatcher,
  getSurveyTypesWatcher,
  getScopeTypesWatcher,
  getSurveysByIndicatorsWatcher,
} from "./actions"

import reducer from "./reducer"
import saga from "./saga"

import SurveysTemplate from "../../components/SurveysTemplate"
import { isModuleBySlug,LOCAL_MODULES } from "../../utils/storage"
import { SEGMENTS } from "../../utils/constants"
// importar rol de usuarios

/* eslint-disable react/prefer-stateless-function */
export class Surveys extends React.Component {
  state = { loadPage: true }

  componentDidMount() {
    if (!JSON.parse(LOCAL_MODULES()).some(module => module.slug === 'surveys')) {
      this.props.history.push("/")
    }
    const isSegmentsEnabled = isModuleBySlug(SEGMENTS)
    this.props.surveysTemplateWatcher()
    // this.props.getSurveyTypes()
    this.props.getScopeTypes()
    this.props.getSurveysByIndicatorsWatcher()
    if (isSegmentsEnabled) {
      this.props.getSegments()
    }
    setTimeout(() => this.setState({ loadPage: false }), 2000)
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Encuestas - Cuestionarios</title>
          <meta name="description" content="Description of Surveys" />
        </Helmet>
        {this.state.loadPage ? <Loader /> : <SurveysTemplate {...this.props} />}
      </React.Fragment>
    )
  }
}

Surveys.propTypes = { dispatch: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  leadershipSurveys: makeSelectLeadershipSurveys(),
  surveySelected: makeSelectGetSurvey(),
  isLoadingSurvey: makeSelectIsLoadingSurvey(),
  surveysTemplate: makeSelectSurveysTemplate(),
  isLoadingSurveysTemplate: makeSelectIsLoadingSurveysTemplate(),
  isLoadingSurveys: makeSelectIsLoadingSurveys(),
  surveyName: makeSelectGetSurveyName(),
  isLoadingSurveyEnps: makeSelectIsLoadingSurveyEnps(),
  surveyEnps: makeSelectSurveyEnps(),
  surveyQualitative: makeSelectSurveyQualitative(),
  isLoadingSurveyQualitative: makeSelectIsLoadingSurveyQualitative(),
  segments: makeSelectSegments(),
  isLoadingSegments: makeSelectIsLoadingSegments(),
  surveyTypes: makeSelectSurveyTypes(),
  isLoadingSurveyTypes: makeSelectIsLoadingSurveyTypes(),
  scopeTypes: makeSelectScopeTypes(),
  isLoadingScopeTypes: makeSelectIsLoadingScopeTypes(),
  surveysByIndicators: makeSelectSurveysByIndicators(),
})

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    createSurvey: (params) => dispatch(createSurvey(params)),
    getSurveyWatcher: (params) => dispatch(getSurveyWatcher(params)),
    surveysTemplateWatcher: () => dispatch(getSurveysTemplateWatcher()),
    duplicateSurveyWatcher: (params) =>
      dispatch(duplicateSurveyWatcher(params)),
    deleteSurveyWatcher: (params) => dispatch(deleteSurveyWatcher(params)),
    getSurveyQualitativeWatcher: (params) =>
      dispatch(getSurveyQualitativeWatcher(params)),
    getSurveyEnpsWatcher: (params) => dispatch(getSurveyEnpsWatcher(params)),
    downloadSurveyWatcher: (params) => dispatch(downloadSurveyWatcher(params)),
    getSegments: (params) => dispatch(getSegmentsWatcher(params)),
    getSurveyTypes: (params) => dispatch(getSurveyTypesWatcher(params)),
    getScopeTypes: (params) => dispatch(getScopeTypesWatcher(params)),
    getSurveysByIndicatorsWatcher: (params) =>
      dispatch(getSurveysByIndicatorsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "surveys", reducer })
const withSaga = injectSaga({ key: "surveys", saga })

export default compose(withReducer, withSaga, withConnect)(Surveys)
